import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { FieldType, FieldTypeConfig, FormlyModule } from '@ngx-formly/core';
import { TranslateModule } from '@ngx-translate/core';

import { IdentityConstants } from '@identity/identity-constants.service';
import { SasDynamicFormService } from '@shared/sas-dynamic-form/sas-dynamic-form.service';
import { FormSubmittedService } from '@shared/services/form-submitted.service';

@Component({
    selector: 'sas-input-password-field-type',
    standalone: true,
    imports: [CommonModule, ReactiveFormsModule, FormlyModule, TranslateModule],
    template: `
        <div class="form-group mb-3 position-relative">
            <label [for]="field.id"
                [id]="field.id + 'Label'"
                [title]="field.props['helptext'] | translate"
                class="form-label"
                [textContent]="field.props.label"
                translate="{{field.props.label}}">
            </label>
            @if (field.props.required) {
                <span> *</span>
            }
            <div [id]="field.id + 'Help'" [title]="field.props['helptext'] | translate" class="sas-inline-block">
                @if (field.props['helptext'] && !isReadonly) {
                <i class="bi bi-info-circle-fill" style="font-size: 15px; cursor: help; margin-left: 5px;"></i>
                }
            </div>
            <input type="password"
                [name]="field.name"
                class="form-control"
                [ngClass]="{'is-invalid': isInvalid}"
                [id]="field.id"
                [attr.sas-id]="field.id"
                [formControl]="formControl"
                placeholder="{{field.props.placeholder! | translate}}"
                maxlength="{{field.props.maxLength}}"
                autocomplete="new-password"
                tabindex="0"
                required="{{field.props.required}}"
                [pattern]="pattern"
                [attr.aria-labelledby]="field.id + 'Label'"
                [attr.aria-required]="field.props.required"
                [attr.aria-describedby]="field.id + 'Help'"/>
                <i class="bi bi-lock-fill position-absolute" aria-hidden="true"></i>
            <div [id]="field.id + 'Desc'" role="alert" aria-atomic="true" class="invalid-feedback">
                <small>{{ sasDynamicFormService.getFieldErrorMessage(field) }}</small>
            </div>
        </div>
    `,
    styleUrl: './sas-input-password-field-type.component.scss'
})
export class SasInputPasswordFieldTypeComponent extends FieldType<FieldTypeConfig> {
    formSubmittedService = inject(FormSubmittedService);
    identityConstants = inject(IdentityConstants).identityConstants;
    sasDynamicFormService = inject(SasDynamicFormService);

    pattern = this.identityConstants.regexPatternPasswordEnhanced;

    get isReadonly(): boolean {
        return (this.field.formControl.disabled || this.field.props.readonly) ?? false;
    }

    get isInvalid() {
        return this.field.formControl.invalid && (this.field.formControl.dirty || this.formSubmittedService.isSubmitted())
    }

    ngOnInit() {
        this.pattern = this.field.props['validation'].pattern || this.identityConstants.regexPatternPasswordEnhanced;
    }
}
